import { useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import Welcome from "@/pages/Welcome";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORE = "fea_state_v1";

const loadState = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORE)) || {};
  } catch {
    return {};
  }
};

function App() {
  const saved = loadState();
  const [screen, setScreen] = useState(saved.screen || "welcome");
  const [answers, setAnswers] = useState(saved.answers || {});
  const [index, setIndex] = useState(saved.index || 0);
  const [result, setResult] = useState(saved.result || null);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    axios.get(`${API}/questions`).then((r) => setMeta(r.data));
  }, []);

  useEffect(() => {
    sessionStorage.setItem(STORE, JSON.stringify({ screen, answers, index, result }));
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [screen, index, result]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    sessionStorage.setItem(STORE, JSON.stringify({ screen, answers, index, result }));
  }, [answers]); // eslint-disable-line react-hooks/exhaustive-deps

  const restart = () => {
    setAnswers({});
    setIndex(0);
    setResult(null);
    setScreen("welcome");
  };

  return (
    <div className="fea-app">
      {screen === "welcome" && <Welcome onBegin={() => setScreen("assessment")} />}
      {screen === "assessment" && (
        <Assessment
          questions={meta?.questions}
          answers={answers}
          setAnswers={setAnswers}
          index={index}
          setIndex={setIndex}
          onExit={() => setScreen("welcome")}
          onComplete={(r) => {
            setResult(r);
            setScreen("results");
          }}
        />
      )}
      {screen === "results" && result && (
        <Results result={result} consentText={meta?.consent_text} onRestart={restart} />
      )}
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
